import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export const homeGoalReportService = async (vendedor?: string): Promise<ResponseAPI> => {
  const response = await api.get('dashboard', { headers: vendedor ? { vendedor } : undefined })

  return response.data
}

